import React, { Component } from "react";
import axios from "axios";
import { NavBar } from "../components/ReusableElements";
import { withRouter } from "react-router-dom";

class Login extends Component {
  constructor() {
    super();

    this.state = {
      username: "",
      password: "",

      showRetryText: false,
      loginClicked: false,
    };
  }

  toggleModal() {
    this.setState({ showModal: !this.state.showModal });
  }

  onValueChange(event) {
    if (event.target.id === "username") {
      this.setState({
        username: event.target.value,
      });
    }

    if (event.target.id === "password") {
      this.setState({
        password: event.target.value,
      });
    }
  }

  handleBroomLogin() {
    var self = this;
    // exchange token for Broom user object
    axios
      .post("/crop/login/", JSON.stringify({}), {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("carousellAuthToken"),
        },
      })
      .then((response) => {
        if (response.data.authorized === true) {
          self.props.getUserData(
            response.data,
            localStorage.getItem("carousellAuthToken")
          ); // bubble user data to the top
          self.props.toggleIsLoggedIn();
          self.props.history.push("/admin");
        } else {
          this.setState({ loginClicked: false });
          this.toggleModal.bind(this);
        }
      })
      .catch((e) => {
        this.setState({ loginClicked: false });
        console.log(e);
      });
  }

  handleLogin() {
    var querystring = require("querystring");

    let data = querystring.stringify({
      username: this.state.username.trim(),
      password: this.state.password,
    });

    // call carousell api
    axios
      .post("/crop/login/", data)
      .then((response) => {
        if (response.status === 200) {
          localStorage.setItem("carousellAuthToken", response.data.token);
          if (response.data.authorized === true) {
            this.props.getUserData(
              response.data,
              localStorage.getItem("carousellAuthToken")
            ); // bubble user data to the top
            this.props.toggleIsLoggedIn();
            this.props.history.push("/admin");
          } else {
            this.setState({ loginClicked: false });
            this.toggleModal.bind(this);
          }
        } else {
          this.setState({ loginClicked: false });
        }
        return response.data;
      })
      .catch(() => {
        this.setState({ showRetryText: true, loginClicked: false, })
      });
  }

  onClickLogin(event) {
    if (this.state.loginClicked) {
      return;
    }
    this.setState({ loginClicked: true });
    event.preventDefault();
    this.handleLogin();
  }

  render() {
    const disableSubmit =
      (this.state.username.length === 0) | (this.state.password.length === 0);
    return (
      <div className="Login">
        <NavBar
          isLoggedIn={this.props.isLoggedIn}
          logout={this.props.toggleIsLoggedIn}
        />
        <div className="login-box">
          <h1 className="login-title">Login</h1>
          <p className="login-description">
            Make sure you use a verified account associated with one of our
            partnered brands.
          </p>
          {this.state.showRetryText === true ? (
            <p style={{ color: "#d2232a" }}>
              Failed to log in. Please try again.
            </p>
          ) : null}
        </div>
        <br />
        <br />
        <div className="login-container">
          <form id="login-form" className="login-form" autoComplete="off">
            <div className="login-form-block">
              <label htmlFor="username" className="login-form-elem">
                Username
              </label>
              <input
                onChange={this.onValueChange.bind(this)}
                id="username"
                className="login-form-input-elem"
                required
              />
            </div>
            <div className="login-form-block">
              <label htmlFor="password" className="login-form-elem">
                Password
              </label>
              <input
                onChange={this.onValueChange.bind(this)}
                type="password"
                id="password"
                className="login-form-input-elem"
                required
              />
            </div>

            <div className="login-form-block">
              <button
                className="login-button"
                style={
                  disableSubmit
                    ? { background: "grey", cursor: "not-allowed" }
                    : null
                }
                disabled={disableSubmit}
                onClick={this.onClickLogin.bind(this)}
              >
                Login
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default withRouter(Login);



// WEBPACK FOOTER //
// ./src/containers/Login.js